import _ from 'lodash';
import axios from 'axios';
import url from 'url';

/**
 * @returns {Promise<string>}
 */
export default async (user, domain) => {
  const token = global.localStorage.getItem('ns_t');

  if (!token) {
    throw Error('getDialPlan function requires a netsapiens access_token from browser local storage');
  }

  if (!user) {
    throw Error('Missing function param 1 "user"');
  }

  if (!domain) {
    throw Error('Missing function param 2 "domain"');
  }

  const { protocol, hostname } = url.parse(global.location.href);

  const { data } = await axios.request({
    method: 'get',
    withCredentials: true,
    url: `${protocol}//${hostname}/ns-api/`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      object: 'subscriber',
      action: 'read',
      user,
      domain,
      fields: 'dial_plan',
      includeDomain: 'yes',
    },
  });

  return _.get(data, ['0', 'dial_plan']);
};
